import { render, staticRenderFns } from "./reactivate-setting.vue?vue&type=template&id=03bc5f31&scoped=true&"
import script from "./reactivate-setting.vue?vue&type=script&lang=js&"
export * from "./reactivate-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bc5f31",
  null
  
)

export default component.exports